import { combineReducers } from 'redux'

import accountsSingleService from './single/accountsSingleService'
import * as singleActions from './single/accountsSingleService.actions'
import { AccountsSingleState } from './accountsService.model'

export const accountsServiceActions = {
  ...singleActions,
}

export const accountsServiceReducers = combineReducers({
  single: accountsSingleService,
})

export interface ModalServiceState {
  single: AccountsSingleState
}
